import React from 'react'
import Select from 'react-select'
import { fnum, sortOpts, getChanges } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import Form from '../ui/Form'

export default class EditPostForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: this.props.data,
      delConf: false,
      errors: {}
    };
  }

  savePost = e => {
    e.preventDefault();
    const oldD = this.props.data;
    const { data } = this.state;
    const toSend = getChanges(data, oldD);
    if(!Object.keys(toSend).length) {
      this.props.cancelEdit();
    }
    else {
      if (toSend.post_srvc_id) {
        toSend.update_costs_srvc = 1;
      }
      if (toSend.post_srvg_id) {
        toSend.update_srvg_id = 1;
      }
      toSend.post_id = data.post_id;
      this.props.editPost(toSend, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelEdit();
        const diffP = data.post_price*data.post_qntt - oldD.post_price*oldD.post_qntt;
        this.props.updtBlnc(diffP, diffP, 0);
      });
    }
  }

  deletePost = e => {
    e.preventDefault();
    const oldD = this.props.data;
    this.props.editPost({
      post_id: oldD.post_id,
      post_active: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.props.cancelEdit();
      const diffP = -oldD.post_price*oldD.post_qntt;
      this.props.updtBlnc(diffP, diffP, 0);
    });
  }

  updateSrvc = e => {
    this.setState({
      data:{
        ...this.state.data,
        post_srvc_id:e.value,
        post_srvg_id:this.props.srvcs[e.value].srvc_srvg_id
      }
    });
  }

  render() {
    const { srvcs, srvgs } = this.props;

    const { data, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deletePost}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    const srvcsOpt = [];
    for (let key in srvcs){
      if(srvcs.hasOwnProperty(key)) {
        if(
          (
            srvcs[key].srvc_type === 1 &&
            srvcs[key].srvc_post === 1 &&
            srvcs[key].srvc_active === 1
          ) ||
          srvcs[key].srvc_id === data.post_srvc_id
        ){
          srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
        }
      }
    }
    srvcsOpt.sort(sortOpts);

    const srvgsOpt = [];
    for (let key in srvgs){
      if(srvgs.hasOwnProperty(key)) {
        if((srvgs[key].srvg_active === 1 && srvgs[key].srvg_prs === 1)
          || srvgs[key].srvg_id === data.post_srvg_id){
          srvgsOpt.push({value:srvgs[key].srvg_id,label:srvgs[key].srvg_desc});
        }
      }
    }
    srvgsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
          <div className="form-group">
            <button  type="button" className="btn btn-success btn-xs"
              onClick={this.savePost}
              title="Сохранить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-default btn-xs"
              onClick={this.props.cancelEdit}
              title="Отменить"
            >
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-danger btn-xs"
              onClick={this.toggleDelConf}
              title="Удалить"
            >
              <span className="glyphicon glyphicon-trash"></span>
            </button>
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control text-editable"
              value={data.post_sort}
              name="post_sort"
              onChange={this.updateInput}
              title="Номер по порядку"
            />
          </div>
          {delConf}
        </td>
        <td>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Услуга&nbsp;</label>
              <div style={{flex: 1}}>
                <Select
                  clearable={false}
                  options={srvcsOpt}
                  value={data.post_srvc_id}
                  onChange={this.updateSrvc}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              name="post_desc"
              value={data.post_desc}
              rows="3"
              title="Описание"
              placeholder="Описание"
              onChange={this.updateInput}
            />
          </div>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Группа&nbsp;</label>
              <div style={{flex: 1}}>
                <Select
                  clearable={false}
                  options={srvgsOpt}
                  value={data.post_srvg_id}
                  onChange={e => this.updateSelect(e,'post_srvg_id')}
                />
              </div>
            </div>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <input type="text"
            className="form-control text-editable"
            value={data.post_price}
            name="post_price"
            onChange={this.updateInput}
          />
        </td>
        <td className="form-group">
          <input type="text"
            className="form-control text-editable"
            value={data.post_qntt}
            name="post_qntt"
            onChange={this.updateInput}
          />
        </td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td className="text-right">{fnum(data.cost_price*data.cost_qntt)}</td>
        <td className="text-right">
          {fnum(data.post_price*data.post_qntt-data.cost_price*data.cost_qntt)}
        </td>
        <td>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              value={data.post_note}
              rows="3"
              placeholder="Заметка"
              title="Заметка"
              name="post_note"
              onChange={this.updateInput}
            />
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSEditPostForm.js